<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 列表数据 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input placeholder="姓名" :readonly="true" v-model="form.name" class="input-with-select">
                            <el-button slot="append" icon="el-icon-search"  :disabled="form.adminSign" @click="findUser()"></el-button>
                        </el-input>
                    </div>
                </div>
                <!-- <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.identityCard" placeholder="身份证"></el-input>
                    </div>
                </div> -->
                <div style="display: inline-block; height:40px;"> 
                    <el-date-picker
                        v-model="form.startDatetime"
                        type="datetime"
                        placeholder="考勤日期开始日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-date-picker
                        v-model="form.endDatetime"
                        type="datetime"
                        placeholder="考勤日期结束日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker> 
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                     &nbsp;&nbsp;
                    <el-button type="primary" @click="exportExcel">导出Excel</el-button>
                </div>
            </div>

             <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all>
                <el-table-column type="index" label="序号" fixed width="55" :index="indexMethod"></el-table-column>
                <el-table-column prop="name" label="姓名" fixed width="100"></el-table-column>
                <el-table-column prop="deptIdstrName" fixed label="部门名称" width="100"></el-table-column>
                <el-table-column prop="identityCard" fixed label="身份证" width="100"></el-table-column>
                <el-table-column prop="sex" label="性别" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sex == 1">
                            男
                        </div>
                        <div v-else-if="scope.row.sex == 2">
                            女
                        </div>
                        <div v-else-if="scope.row.sex == 0">
                            未知
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="workDate" label="考勤日期" width="100"></el-table-column>
                <el-table-column prop="classesName" label="班次" width="100"></el-table-column>
                <el-table-column prop="" label="上班1" width="150" align="center">
                    <el-table-column prop="up1RealCardTime" label="打卡时间" width="100"></el-table-column>
                    <el-table-column prop="up1Status" label="打卡结果" width="50" >
                        <template slot-scope="scope">
                            <div v-if="scope.row.up1Status == 1">
                                <div v-if="!form.adminSign">
                                    <span @click="setCellData(scope.row,'up1Status')" style="cursor:pointer">旷工</span>
                                </div>
                                <div v-else>
                                    旷工
                                </div>
                            </div>
                            <div v-else-if="scope.row.up1Status == 2">
                                正常
                            </div>
                            <div v-else-if="scope.row.up1Status == 3">
                                <div v-if="!form.adminSign">
                                    <span @click="setCellData(scope.row,'up1Status')" style="cursor:pointer">迟到</span>
                                </div>
                                <div v-else>
                                    迟到
                                </div>
                            </div>
                            <div v-else-if="scope.row.up1Status == 4">
                                <div v-if="!form.adminSign">
                                    <span @click="setCellData(scope.row,'up1Status')" style="cursor:pointer">缺卡</span>
                                </div>
                                <div v-else>
                                    缺卡
                                </div>
                            </div>
                            <div v-else-if="scope.row.up1Status == 5">
                                病假
                            </div>
                            <div v-else-if="scope.row.up1Status == 6">
                                事假
                            </div>
                            <div v-else>
                                无
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column prop="" label="下班1" width="150" align="center">
                    <el-table-column prop="down1RealCardTime" label="打卡时间" width="100"></el-table-column>
                    <el-table-column prop="down1Status" label="打卡结果" width="50" >
                        <template slot-scope="scope">
                            <div v-if="scope.row.down1Status == 1">
                                <div v-if="!form.adminSign">
                                    <span @click="setCellData(scope.row,'down1Status')" style="cursor:pointer">旷工</span>
                                </div>
                                <div v-else>
                                    旷工
                                </div>
                            </div>
                            <div v-else-if="scope.row.down1Status == 2">
                                正常
                            </div>
                            <div v-else-if="scope.row.down1Status == 3">
                                <div v-if="!form.adminSign">
                                    <span @click="setCellData(scope.row,'down1Status')" style="cursor:pointer">迟到</span>
                                </div>
                                <div v-else>
                                    迟到
                                </div>
                            </div>
                            <div v-else-if="scope.row.down1Status == 4">
                                <div v-if="!form.adminSign">
                                    <span @click="setCellData(scope.row,'down1Status')" style="cursor:pointer">缺卡</span>
                                </div>
                                <div v-else>
                                    缺卡
                                </div>
                            </div>
                            <div v-else-if="scope.row.down1Status == 5">
                                病假
                            </div>
                            <div v-else-if="scope.row.down1Status == 6">
                                事假
                            </div>
                            <div v-else>
                                无
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                
                <el-table-column prop="" label="上班2" width="150" align="center">
                    <el-table-column prop="up2RealCardTime" label="打卡时间" width="100"></el-table-column>
                    <el-table-column prop="up2Status" label="打卡结果" width="50">
                        <template slot-scope="scope">
                            <div v-if="scope.row.up2Status == 1">
                                <div v-if="!form.adminSign">
                                    <span @click="setCellData(scope.row,'up2Status')" style="cursor:pointer">旷工</span>
                                </div>
                                <div v-else>
                                    旷工
                                </div>
                            </div>
                            <div v-else-if="scope.row.up2Status == 2">
                                正常
                            </div>
                            <div v-else-if="scope.row.up2Status == 3">
                                <div v-if="!form.adminSign">
                                    <span @click="setCellData(scope.row,'up2Status')" style="cursor:pointer">迟到</span>
                                </div>
                                <div v-else>
                                    迟到
                                </div>
                            </div>
                            <div v-else-if="scope.row.up2Status == 4">
                                <div v-if="!form.adminSign">
                                    <span @click="setCellData(scope.row,'up2Status')" style="cursor:pointer">缺卡</span>
                                </div>
                                <div v-else>
                                   缺卡
                                </div>
                            </div>
                            <div v-else-if="scope.row.up2Status == 5">
                                病假
                            </div>
                            <div v-else-if="scope.row.up2Status == 6">
                                事假
                            </div>
                            <div v-else>
                                无
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column prop="" label="下班2" width="150" align="center">
                    <el-table-column prop="down2RealCardTime" label="打卡时间" width="100"></el-table-column>
                    <el-table-column prop="down2Status" label="打卡结果" width="50">
                        <template slot-scope="scope">
                            <div v-if="scope.row.down2Status == 1">
                                <div v-if="!form.adminSign">
                                    <span @click="setCellData(scope.row,'down2Status')" style="cursor:pointer">旷工</span>
                                </div>
                                <div v-else>
                                    旷工
                                </div>
                            </div>
                            <div v-else-if="scope.row.down2Status == 2">
                                正常
                            </div>
                            <div v-else-if="scope.row.down2Status == 3">
                                <div v-if="!form.adminSign">
                                    <span @click="setCellData(scope.row,'down2Status')" style="cursor:pointer">迟到</span>
                                </div>
                                <div v-else>
                                    迟到
                                </div>
                            </div>
                            <div v-else-if="scope.row.down2Status == 4">
                                <div v-if="!form.adminSign">
                                    <span @click="setCellData(scope.row,'down2Status')" style="cursor:pointer">缺卡</span>
                                </div>
                                <div v-else>
                                    缺卡
                                </div>
                            </div>
                            <div v-else-if="scope.row.down2Status == 5">
                                病假
                            </div>
                            <div v-else-if="scope.row.down2Status == 6">
                                事假
                            </div>
                            <div v-else>
                                无
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>

                <!-- <el-table-column prop="" label="上班3" width="150" align="center">
                    <el-table-column prop="up3RealCardTime" label="打卡时间" width="100"></el-table-column>
                    <el-table-column prop="up3Status" label="打卡结果" width="50">
                        <template slot-scope="scope">
                            <div v-if="scope.row.up3Status == 1">
                               旷工
                            </div>
                            <div v-else-if="scope.row.up3Status == 2">
                                正常
                            </div>
                            <div v-else-if="scope.row.up3Status == 3">
                                迟到
                            </div>
                            <div v-else-if="scope.row.up3Status == 4">
                                缺卡
                            </div>
                            <div v-else-if="scope.row.up3Status == 5">
                                病假
                            </div>
                            <div v-else-if="scope.row.up3Status == 6">
                                事假
                            </div>
                            <div v-else>
                                无
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column prop="" label="下班3" width="150" align="center">
                    <el-table-column prop="down3RealCardTime" label="打卡时间" width="100"></el-table-column>
                    <el-table-column prop="down3Status" label="打卡结果" width="50">
                        <template slot-scope="scope">
                            <div v-if="scope.row.down3Status == 1">
                               旷工
                            </div>
                            <div v-else-if="scope.row.down3Status == 2">
                                正常
                            </div>
                            <div v-else-if="scope.row.down3Status == 3">
                                迟到
                            </div>
                            <div v-else-if="scope.row.down3Status == 4">
                                缺卡
                            </div>
                            <div v-else-if="scope.row.down3Status == 5">
                                病假
                            </div>
                            <div v-else-if="scope.row.down3Status == 6">
                                事假
                            </div>
                            <div v-else>
                                无
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column> -->

                <el-table-column prop="attendanceDays" label="出勤天数" width="80"></el-table-column>
                <el-table-column prop="workHours" label="工作时长(分钟)" width="100"></el-table-column>
                <el-table-column prop="lateCount" label="迟到次数" width="80"></el-table-column>
                <el-table-column prop="lateMinute" label="迟到时长(分钟)" width="100"></el-table-column>
                <el-table-column prop="upLackCount" label="上班缺卡次数" width="100"></el-table-column>
                <el-table-column prop="downLackCount" label="下班缺卡次数" width="100"></el-table-column>
                <el-table-column prop="absenteeismCount" label="旷工次数" width="100"></el-table-column>
                <el-table-column prop="thingLeaveHours" label="事假天数" width="100"></el-table-column>
                <el-table-column prop="sickLeaveHours" label="病假天数" width="100"></el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>

        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
        <!-- 新增弹出框-->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../common/http';
    // import userTransfer from './UserTransfer.vue';
    import userTransfer from '../sys/user/UserTransfer.vue';
    import add from './Add.vue'; 

    export default {
        name:"TeacherDay",
        data(){
            return{
                menuName:"",
                transferVisible:false,
                addVisible:false,
                loading:false,
                loadingText:"",
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    userId:"",
                    name:"",
                    adminSign:true,
                    startDatetime:"",
                    endDatetime:"",
                    deptId:""
                },
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                depts:[],
                data:[]
            }
        },
        components: {
            userTransfer,add
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list;
                       if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // deptCheck(){
            //    this.deptId=this.$refs['rootTree'].getCheckedKeys();
            //    this.getData();
            // },
            getData(){
                this.loading=true;
                this.loadingText="正在加载中...";
                let url  = this.listTeacherDayUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    userId:this.form.userId,
                    startDatetime:this.form.startDatetime==null?"":this.form.startDatetime,
                    endDatetime:this.form.endDatetime==null?"":this.form.endDatetime,
                    deptId:this.form.deptId
                };       
                // console.log(JSON.stringify(data))
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.data = res.data.list;
                        this.common.total=res.data.total;
                       // 如果用户ID为空，表示首次进来，要初始用户信息
                    //    console.log("用户ID："+this.form.userId+"；是否为空:"+this.$util.isEmpty(this.form.userId));
                        if(this.$util.isEmpty(this.form.userId)){
                           this.form.userId=res.data.userId;
                           this.form.name=res.data.name;
                           this.form.adminSign=!res.data.adminSign;
                        }
                        this.loading=false;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                        this.loading=false;
                    }
                },(err)=>{

                });
            },
            exportExcel(){
                let msg="导出考勤数据只支持导出1W条，超出会导出失败，请确认当前页面总条数！";
                this.$commonFn.showConfirm2(msg,this.exportData);
            },
            exportData(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";
                let url=this.exportAttendanceDetailTeacherDayUrl;
                let param = new URLSearchParams();
                // param.append('isPage', this.common.isPage);
                // param.append('page', this.common.page);
                // param.append('limit', this.common.pageSize);
                param.append('userId', this.form.userId);
                param.append('startDatetime',(this.form.startDatetime==null?"":this.form.startDatetime));
                param.append('endDatetime', (this.form.endDatetime==null?"":this.form.endDatetime));
                param.append('deptId', this.form.deptId);
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    // console.log(decodeURI(res.headers['filename']));
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '教职个人考勤明细.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    // this.$Notice.error({
                    //     title: "错误",
                    //     desc: "系统数据错误"
                    // });
                    console.log(error);
                    this.loading=false;
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.trafficRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            //批量删除管理员
            batchDelete(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array();
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }
                    let idStr =checkIdArr.join(",");
                    this.form.id= idStr;
                    this.$commonFn.showConfirm(this.delSuccess);
                }
                else{
                    this.$commonFn.showTip("请选择删除数据",2);
                }
            },
            handleSelectionChange(val){
                this.common.checkboxArr = [];
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id);
                }
            },
            findUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    this.$refs['userTransfer'].init(2,null,1,this.form.deptId);
                })
            },
            setUser(userId,name){
                this.form.userId = userId;
                this.form.name = name;
            },
            // 设置单元格，修改上报状态值
            setCellData(row,column){
               //获取班次类型允许修改
               let url = this.getClassesUrl;
               let data = {
                    id:row.classesId
               };
               this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        console.log(JSON.stringify(res.data))
                        let type=0;
                        if(column == 'up1Status'){
                            type=1;
                        }else if(column == 'down1Status'){
                            type=2; 
                        }else if(column == 'up2Status'){
                            type=3;
                        }else if(column == 'down2Status'){
                            type=4; 
                        }
                        if((type == 3  || type ==4) && res.data.classesType==1){
                            return;
                        }

                        this.addVisible=true;
                        this.$nextTick(() => {
                            this.$refs['add'].init(row.id,type);
                        })
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                }) 
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/count/TeacherDay.vue